// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import dayJs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezoneDayJs from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayJs.extend(advancedFormat);
dayJs.extend(utc);
dayJs.extend(timezoneDayJs);

export interface FormatTimeOptions {
  readonly year?: boolean;
  readonly time?: boolean;
  readonly removeDayOfWeek?: boolean;
  readonly shortenDayOfMonth?: boolean;
  readonly compactDisplay?: boolean;
  readonly shortenDayOfWeek?: boolean;
  readonly timezone?: string;
}

export default (timeSeconds: number, options?: FormatTimeOptions) => {
  const {
    year = false,
    time = false,
    removeDayOfWeek = false,
    shortenDayOfMonth = false,
    compactDisplay = false,
    shortenDayOfWeek = false,
    timezone,
  } = options || {};
  let day = dayJs.unix(timeSeconds);
  if (timezone) {
    day = day.tz(timezone);
  }

  const inputYear = day.year();
  const currentYear = dayJs()
    .tz(timezone || 'Pacific/Kiritimati')
    .year();
  const inputYearDifferentFromCurrentYear = inputYear !== currentYear;
  const displayYear = (year || inputYearDifferentFromCurrentYear) && !compactDisplay;

  return day.format(
    `${removeDayOfWeek ? '' : shortenDayOfWeek || compactDisplay ? 'dd, ' : 'ddd, '}MMM ${
      shortenDayOfMonth || compactDisplay ? 'D' : 'Do'
    }${displayYear ? ", 'YY" : ''}${time ? ', h:mm A' : ''}`,
  );
};
